/* 路由权限 */

// 根据权限获取路由列表，并给传入的菜单列表加上icon
export function getRouteListByPermission(permissionList, routeDataList) {
  // 菜单和路由列表
  const routeListCur = getRouteListByLoop(permissionList, routeDataList)
  return routeListCur
}

// 循环获取菜单和路由，权限列表用路径或者路由名称来匹配
function getRouteListByLoop(permissionList, routeDataList, routePathAddedList) {
  const routeListCur = []
  if (
    permissionList !== undefined &&
    permissionList !== null &&
    permissionList.length > 0 &&
    routeDataList !== undefined &&
    routeDataList !== null &&
    routeDataList.length > 0
  ) {
    routePathAddedList =
      routePathAddedList === undefined || routePathAddedList === null
        ? []
        : routePathAddedList // 已添加的权限的路径集合
    for (let i = 0; i < routeDataList.length; i++) {
      const routeDataItem = routeDataList[i] // 路由对象
      if (
        routeDataItem.name === 'layout' ||
        routeDataItem.isHidden === true ||
        (routeDataItem.meta.routeNameParent !== undefined &&
          routeDataItem.meta.routeNameParent !== null &&
          routeDataItem.meta.routeNameParent !== '')
      ) {
        continue // 跳过不显示的和首页
      }

      let routeItemCur = null // 当前路由，会添加到权限路由集合中
      for (let m = 0; m < permissionList.length; m++) {
        const permissionItem = permissionList[m] // 权限对象
        if (routePathAddedList.indexOf(permissionItem.url.toLowerCase()) >= 0) {
          continue
        }

        if (
          (routeDataItem.name !== undefined &&
            routeDataItem.name !== null &&
            routeDataItem.name !== '' &&
            routeDataItem.name === permissionItem.name) ||
          (routeDataItem.path !== '' &&
            routeDataItem.path.toLowerCase() ===
              permissionItem.url.toLowerCase())
        ) {
          routeItemCur = Object.assign({}, routeDataItem) // 有权限的路由
          routeItemCur.meta = Object.assign({}, routeDataItem.meta)
          routeItemCur.meta.buttons = permissionItem.buttons // 有权限的按钮集合

          routeListCur.push(routeItemCur) // 添加到路由集合
          routePathAddedList.push(routeItemCur.path.toLowerCase()) // 已添加的权限的路径集合
          break
        }
      }
      if (routeItemCur !== null || routeDataItem.isOnlyOneLevel === true) {
        // 如果权限路由匹配到了，则跳到下一个继续匹配
        // 或者如果只有一级目录，则不再匹配子路由，跳到下一个继续匹配
        continue
      }

      // 没有匹配到或不是只有一级目录，则查找子路由中是否有匹配
      const routeChildren = routeDataItem.children // 所有子路由
      let routeChildrenCur = getRouteListByLoop(
        permissionList,
        routeChildren,
        routePathAddedList
      ) // 根据菜单权限筛选出的子路由

      if (
        routeChildrenCur !== undefined &&
        routeChildrenCur !== null &&
        routeChildrenCur.length > 0
      ) {
        // 存在匹配到的子路由，则说明该路由有权限，则添加到路由集合中
        routeItemCur = Object.assign({}, routeDataItem) // 有权限的路由

        // 子路由的新增、编辑、详细等子页面
        const routeChildChildren = []
        routeChildrenCur.forEach(function(itemChildCur) {
          // itemChildCur为当前路由中被添加到路由集合中的路由对象
          routeChildren.forEach(function(itemChild) {
            // itemChild为当前路由的所有子路由的路由对象
            if (
              itemChildCur.name !== undefined &&
              itemChildCur.name !== null &&
              itemChildCur.name !== '' &&
              itemChildCur.name === itemChild.meta.routeNameParent
            ) {
              // 如果被添加的路由对象的name和新增、编辑、详细等子页面的父路由name相同，则添加到子路由集合中
              const itemChildNew = Object.assign({}, itemChild)
              routeChildChildren.push(itemChildNew)
              return
            }
          })
        })

        routeChildrenCur = routeChildrenCur.concat(routeChildChildren) // 子路由数组合并
        routeItemCur.children = routeChildrenCur
        routeListCur.push(routeItemCur) // 添加到路由集合
        routePathAddedList.push(routeItemCur.path.toLowerCase()) // 已添加的权限的路径集合
        continue
      }
    }
  }
  if (routeListCur.length > 0) {
    const aa = routePathAddedList.length
  }

  return routeListCur
}
